





































































import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
import { EscalatedAlert, EscalatedAlertStatus } from '@/api';

@Component({})
export default class EscalatedAlertTable extends Vue {
	@Prop({ required: true, type: String })
	public readonly pageStatus!: EscalatedAlertStatus;

	@Prop({ required: true, type: Array })
	public alerts!: EscalatedAlert[];

	@Prop({ required: true, type: Number })
	public perPage!: number;

	@Prop({ required: true, type: Number })
	public currentPage!: number;

	@Prop({ required: true, type: Number })
	public totalRows!: number;

	@Prop({ required: true, type: Boolean })
	public loading!: number;

	// Table fields

	public localCurrentPage: number = this.currentPage;

	public findLogKey() {
		switch (this.pageStatus) {
			case EscalatedAlertStatus.New:
				return 'created_at';
			default:
				return 'last_logged_date';
		}
	}

	public findLogLabel() {
		switch (this.pageStatus) {
			case EscalatedAlertStatus.New:
				return 'Created At';
			case EscalatedAlertStatus.Resolved:
				return 'Resolved At';
			default:
				return 'Last Log';
		}
	}

	public getRowColouredLogs(arr: EscalatedAlert[]): any[] {
		return arr.map((alert) => {
			const lastTime = new Date(alert[this.findLogKey()]).getTime();
			const now = new Date().getTime();
			const successTime = 30 * 60 * 1000;
			const warningTime = 75 * 60 * 1000;

			if (this.pageStatus === EscalatedAlertStatus.Resolved) return alert;
			if (lastTime == null) return alert;
			if (lastTime > now - successTime) {
				return { ...alert, _rowVariant: 'custom-success' };
			} else if (lastTime > now - warningTime) {
				return { ...alert, _rowVariant: 'custom-warning' };
			} else {
				return { ...alert, _rowVariant: 'custom-danger' };
			}

		});
	}

	public fields = [
		{
			key: this.findLogKey(),
			label: this.findLogLabel(),
		},
		{
			key: 'id',
			label: 'Id',
		},
		{
			key: 'product.name',
			label: 'Product',
		},
		{
			key: 'product.supplierNumber',
			label: 'Supplier No.',
		},
		{
			key: 'event.title',
			label: 'Event',
		},
		{
			key: 'product_tier',
			label: 'Trial',
		},
		...(this.pageStatus === 'monitor' ? [{ key: 'has_been_escalated', label: 'Already Escalated' }] : []),
		{
			key: 'product.notes',
			label: 'Notes',
		},
	];

	// Fields for only if "resolved" tab is selected

	resolvedFields = [
		...this.fields,
		{ key: 'is_save', label: 'Save' },
		{ key: 'is_valid', label: 'Valid' },
		{ key: 'save_volume', label: 'Volume' },
		{ key: 'resolution_reason', label: 'Reason' },
	];

	public handlePageChange(newPage: number) {
		if (this.localCurrentPage === newPage) return;
		this.localCurrentPage = newPage;
		this.emitPageChange(newPage)
	}

	@Emit('update:currentPage')
	public emitPageChange(newPage: number) {
		return newPage;
	}

	@Emit('table-click')
	public handleTablePress(alert: EscalatedAlert) {
		return alert;
	}

	public get paginationText() {
		return `${this.perPage * (this.currentPage - 1) + 1} - ${Math.min(
			this.totalRows,
			this.perPage * this.currentPage,
		)} of ${this.totalRows} faults`
	}
}
